import React, { useEffect, useState } from "react";
import { Dropdown } from "antd";
import { useMediaQuery } from "react-responsive";
import { DownCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  setHeadings,
  setselectedTab,
  setSubHeadings,
} from "../../../Store/B2bslice";
import { getBBPS3OperatorCategory } from "../../../ApiServices/Apifun";
import { ThemeColor } from "../../../Theme/theme";
import NotAvailable from "../../../Routes/NotAvailable";
import { Mobile_PostPaid } from "../../../Assets/mobile postpaid";
import BillPayment3 from "./BillPayment3";
const BBPS3 = () => {
  const dispatch = useDispatch();
  const [selection, setSelection] = useState("");
  const [allOperatorsCategory, setAllOperatorsCategory] = useState([]);
  const isExtraLargeScreen = useMediaQuery({ minWidth: 1501, maxWidth: 4000 });
  const isLargeScreen = useMediaQuery({ minWidth: 992, maxWidth: 1500 });
  const isMediumScreen = useMediaQuery({ minWidth: 768, maxWidth: 991 });
  const isSmallScreen = useMediaQuery({ minWidth: 400, maxWidth: 767 });
  const isExtraSmallScreen = useMediaQuery({ minWidth: 250, maxWidth: 500 });
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const [searchParam] = useSearchParams();

  const getAllOperatorsCategory = () => {
    getBBPS3OperatorCategory().then((res) => {
      if (res.status) {
        console.log(res.data?.services);
        setAllOperatorsCategory(
          res.data?.services?.map((i, id) => ({
            service_name: i.service_name,
            component: !memberServices.includes("305") ? (
              <NotAvailable />
            ) : (
              <BillPayment3
                selection={i.service_name}
                service_id={i.service_id}
                type={i.key}
              />
            ),

            key: id,
          })),
        );
      }
    });
  };

  useEffect(() => {
    getAllOperatorsCategory();
  }, [selection]);

  //   useEffect(() => {
  //     const service = searchParam.get("service");
  //     console.log("test", service);
  //     setSelection(service);
  //   }, [searchParam]);

  const itemsToShow = isExtraLargeScreen
    ? 12
    : isLargeScreen
      ? 10
      : isMediumScreen
        ? 5
        : isSmallScreen
          ? 4
          : isExtraSmallScreen
            ? 1
            : allOperatorsCategory.length;

  // const items = tabNames.slice(itemsToShow).map((item, index) => {
  //   return (
  //     <div
  //       key={index}
  //       onClick={() => setSelection(item.name)}
  //       className="flex bg-primary hover:bg-primaryhover rounded-full  text-white p-2 justify-around w-14 h-14 items-center"
  //     >
  //       {/* <img src={item.image} className="" alt="service_image" width={"15px"} /> */}
  //       <div>{item.image}</div>
  //       <p className=" cursor-pointer flex justify-end items-start transition-all bg-transparent   font-bold rounded-sm text-[13px] px-5">
  //         {item.name}
  //       </p>
  //     </div>
  //   );
  // });
  const items = allOperatorsCategory.slice(itemsToShow).map((item, index) => {
    0;
    return {
      key: index,
      label: (
        <div
          key={index}
          onClick={() => setSelection(item.service_name)}
          className="flex bg-primary hover:bg-primaryhover rounded-md text-white p-2 justify-start w-full items-center"
        >
          {/* <img
            src={item.image}
            className=""
            alt="service_image"
            width={"15px"}
          /> */}
          <Mobile_PostPaid style={ThemeColor.bswhite} />
          {/* <div>{item?.image}</div> */}

          <p className=" cursor-pointer capitalize flex justify-end items-center transition-all bg-transparent   font-bold rounded-sm text-[13px] px-5">
            {item.service_name}
          </p>
        </div>
      ),
    };
  });
  useEffect(() => {
    dispatch(setSubHeadings(""));
    dispatch(setselectedTab("108"));
    dispatch(setHeadings("Operator Category"));
  }, [selection]);

  return (
    <>
      <div className="All_services bg-white p-10 rounded-md mb-5 gap-2 md:gap-2 flex justify-around flex-wrap items-center">
        {allOperatorsCategory
          ?.sort((a, b) => a.service_name.localeCompare(b.service_name))
          .slice(0, itemsToShow)
          .map((item, index) => {
            return (
              <div
                key={index}
                className="place-items-center text-start"
                style={{
                  height: "-webkit-fill-available",
                  width: "70px",
                }}
              >
                <div
                  onClick={() => setSelection(item.service_name)}
                  className="p-1 md:p-3 w-10 md:w-14  h-10 md:h-14 hover:scale-110  cursor-pointer hover:opacity-100 bg-primary rounded-full hover:bg-primaryhover text-white transition-all flex flex-col justify-center items-center font-bold  "
                >
                  <Mobile_PostPaid style={ThemeColor.bswhite} />
                </div>
                <p className={`text-[13px] font-semibold text-center`}>
                  {item.service_name}
                </p>
                {selection === item.service_name ? (
                  <div className="animate-slide-in mt-1 border border-primary "></div>
                ) : (
                  ""
                )}
              </div>
            );
          })}
        {(isExtraLargeScreen ||
          isLargeScreen ||
          isMediumScreen ||
          isSmallScreen ||
          isExtraSmallScreen) && (
          <Dropdown
            className="dropdownMenu"
            menu={{ items }}
            trigger={["click"]}
          >
            <div className="p-1 md:p-3 w-10 md:w-14  h-10 md:h-14  cursor-pointer bg-primary mb-4 rounded-full hover:opacity-60 text-white transition-all  border border-primary font-bold flex flex-col gap-y-1 justify-center items-center text-xs ">
              <p className="text-xs md:sm font-thin md:font-medium">More</p>
              <DownCircleOutlined className="" />
            </div>
          </Dropdown>
        )}
      </div>

      {
        allOperatorsCategory.filter(
          (item, index) => item.service_name === selection,
        )[0]?.component
      }
    </>
  );
};

export default BBPS3;
